import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SkiletonLoaderDirective} from './skileton-loader.directive';

@NgModule({
    declarations: [SkiletonLoaderDirective],
    exports: [
        SkiletonLoaderDirective
    ],
    imports: [
        CommonModule
    ]
})
export class SkeletonDirectiveModule { }
